'use client';

import React from 'react';

/**
 * CSS Film Grain & Micro-Noise Overlay (Trend 2026)
 * Убирает ощущение «пластикового цифрового экрана», создавая эффект 
 * дорогой швейцарской полиграфии, шелкографии и кинематографической пленки.
 * Процедурный SVG-шум с нулевой нагрузкой на процессор (чистый SVG feTurbulence).
 */
export const FilmGrainOverlay: React.FC = () => {
  return (
    <div 
      aria-hidden="true" 
      className="pointer-events-none fixed inset-0 z-50 overflow-hidden mix-blend-overlay opacity-[0.035]"
    >
      <svg className="w-full h-full" xmlns="http://www.w3.org/2000/svg">
        <filter id="swiss-film-grain">
          <feTurbulence 
            type="fractalNoise" 
            baseFrequency="0.85" 
            numOctaves="3" 
            stitchTiles="stitch" 
          />
          <feColorMatrix type="saturate" values="0" />
        </filter>
        <rect width="100%" height="100%" filter="url(#swiss-film-grain)" />
      </svg>
    </div>
  );
};
